export const DASH_SYMBOL = '—';
